import React, { useEffect, useState } from "react";
import { cautionSvg } from "../../components/Assets";

function AppConnectErrorPanel({ errorApps }) {
  const [errorAppsName, setErrorAppsName] = useState();

  useEffect(() => {
    let errorAppsName = errorApps.map(x => x.appName).join();
    setErrorAppsName(errorAppsName);
  }, [])
  return (
    <div className="flex items-center gap-3 bg-gray p-3 mt-6 rounded">
      <span>
        <img src={cautionSvg} style={{ width: "20px", height: "20px" }} />
      </span>
      <p className="flex flex-col gap-1 text-sm">
        <b>{errorAppsName} 연동에 문제가 생겼어요!</b>
        <span>배달 앱 연동에서 계정을 확인해주세요.</span>
      </p>
    </div>
  );
}

export default AppConnectErrorPanel;
